import * as echarts from 'echarts';

export const UK_MAP_NAME = 'UKRegions';

// Postcode area → UK EER region (11 regions matching uk-regions.json feature names)
export const POSTCODE_REGION = {
  'NE':'North East','DH':'North East','SR':'North East','TS':'North East','DL':'North East',
  'M':'North West','L':'North West','WA':'North West','PR':'North West','BB':'North West',
  'FY':'North West','LA':'North West','BL':'North West','OL':'North West','WN':'North West',
  'SK':'North West','CH':'North West','CW':'North West',
  'LS':'Yorkshire and The Humber','BD':'Yorkshire and The Humber','WF':'Yorkshire and The Humber',
  'HX':'Yorkshire and The Humber','HD':'Yorkshire and The Humber','HG':'Yorkshire and The Humber',
  'YO':'Yorkshire and The Humber','DN':'Yorkshire and The Humber','S':'Yorkshire and The Humber',
  'HU':'Yorkshire and The Humber',
  'NG':'East Midlands','DE':'East Midlands','LE':'East Midlands','NN':'East Midlands',
  'LN':'East Midlands','PE':'East Midlands','MK':'East Midlands',
  'B':'West Midlands','WV':'West Midlands','WS':'West Midlands','DY':'West Midlands',
  'WR':'West Midlands','ST':'West Midlands','TF':'West Midlands','HR':'West Midlands',
  'CV':'West Midlands','SY':'West Midlands',
  'CB':'Eastern','CO':'Eastern','CM':'Eastern','IP':'Eastern','NR':'Eastern',
  'SG':'Eastern','SS':'Eastern','AL':'Eastern','HP':'Eastern','LU':'Eastern',
  'E':'London','EC':'London','N':'London','NW':'London','SE':'London','SW':'London',
  'W':'London','WC':'London','HA':'London','BR':'London','CR':'London','DA':'London',
  'EN':'London','IG':'London','KT':'London','RM':'London','SM':'London','TW':'London',
  'UB':'London','WD':'London',
  'BN':'South East','CT':'South East','GU':'South East','ME':'South East',
  'PO':'South East','RG':'South East','RH':'South East','SL':'South East',
  'SO':'South East','TN':'South East','GY':'South East','JE':'South East','SP':'South East',
  'BS':'South West','BA':'South West','BH':'South West','DT':'South West','EX':'South West',
  'GL':'South West','PL':'South West','TA':'South West','TQ':'South West','TR':'South West',
  'AB':'Scotland','DD':'Scotland','DG':'Scotland','EH':'Scotland','FK':'Scotland',
  'G':'Scotland','HS':'Scotland','IV':'Scotland','KA':'Scotland','KW':'Scotland',
  'KY':'Scotland','ML':'Scotland','PA':'Scotland','PH':'Scotland','TD':'Scotland','ZE':'Scotland',
  'CF':'Wales','LD':'Wales','LL':'Wales','NP':'Wales','SA':'Wales',
  'BT':'Northern Ireland',
};

// Reverse: region → list of postcode codes
export const REGION_POSTCODES = Object.entries(POSTCODE_REGION).reduce((acc, [code, region]) => {
  (acc[region] = acc[region] || []).push(code);
  return acc;
}, {});

// Load and register the UK regions GeoJSON exactly once
let _mapState = 'idle';
const _waiters = [];

export function loadUKMap(onDone) {
  if (_mapState === 'ready') { onDone(true);  return; }
  if (_mapState === 'error') { onDone(false); return; }
  _waiters.push(onDone);
  if (_mapState === 'loading') return;
  _mapState = 'loading';
  fetch('/maps/uk-regions.json')
    .then(r => { if (!r.ok) throw new Error(`HTTP ${r.status}`); return r.json(); })
    .then(geo => {
      echarts.registerMap(UK_MAP_NAME, geo);
      _mapState = 'ready';
      _waiters.forEach(fn => fn(true));
      _waiters.length = 0;
    })
    .catch(err => {
      console.error('UK GeoJSON load failed:', err);
      _mapState = 'error';
      _waiters.forEach(fn => fn(false));
      _waiters.length = 0;
    });
}
